import QueueUploadView from './QueueUploadPage';

const QueueUploadPage = {
    name: 'QueueUpload',
    list: QueueUploadView
};

export default QueueUploadPage;
